
var smallDeviceWidth = 767; 
var throttleLimit = 300; 
var nodeChanged = false;
var parentElement = document.getElementById("row-rail");
var colRail = document.getElementById("col-rail");
var colMain = document.getElementById("col-main");
var relatedArticles = document.getElementById("relatedArticles");

const throttle = (func, limit) => {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

function windowSizeHandler() {

  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  if (width <= smallDeviceWidth  && !nodeChanged) {
    if (relatedArticles) {
        relatedArticles.parentNode.insertBefore(colRail, relatedArticles);
        nodeChanged = true;
    } else if (colMain){
        parentElement.insertBefore(colRail, colMain.nextSibling);
        nodeChanged = true;
    } else if (width > smallDeviceWidth  && nodeChanged) {
      nodeChanged = false;
      parentElement.insertBefore(colRail, colMain);
    } 
  }
}

window.addEventListener("resize", throttle(windowSizeHandler, throttleLimit));
window.addEventListener("load", windowSizeHandler);
